import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { AuthRoot } from '../featureComponents/auth/AuthRoot';
import { ForgotPassword, ForgotPasswordProps } from '../featureComponents/auth/ForgotPassword';
import { Login, LoginProps } from '../featureComponents/auth/Login';
import { ResetPassword, ResetPasswordProps } from '../featureComponents/auth/ResetPassword';

interface AuthRootProps extends LoginProps, ForgotPasswordProps, ResetPasswordProps {}

export const authRoutes = (props: AuthRootProps): RouteObject[] => {
  const { appName, onLogin, onResetPassword } = props;
  return [
    {
      path: '/auth',
      element: <AuthRoot />,
      children: [
        { path: 'login', element: <Login appName={appName} onLogin={onLogin} /> },
        { path: 'forgot-password', element: <ForgotPassword appName={appName} /> },
        {
          path: 'reset-password/:resetToken',
          element: <ResetPassword appName={appName} onResetPassword={onResetPassword} />
        },
        // NOTE: this is a redirect, so if someone went to /auth, we'll take them to login
        { path: '', element: <Navigate to='../login' /> }
      ]
    }
  ];
};
